module.exports = __webpack_public_path__ + "static/media/cca_logo.19293fbf.svg";